
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./kfc-styles.cjs.production.min.js')
} else {
  module.exports = require('./kfc-styles.cjs.development.js')
}
